<template>
  <div class="records" style="margin-top: -10px">
    <!--  heading block -->
    <GlobalHeader :title="'Payment for ' + lists.list_no" @redirectPage="redirectPage"></GlobalHeader>
    <!-- Validation for records -->
    <b-row class="mt-2 px-pad">
      <b-col xl="12" lg="12" md="12" xs="12" sm="12" class="px-0">
        <div class="container-fluid">
          <b-alert class="alert-transparent alert-danger" :show="duplicatecode">
            <p class="fw-semi-bold">{{ message||status_message }}</p>
          </b-alert>
          <b-alert
            class="alert-transparent alert-danger"
            :show="error_show && this.errors.any()"
          >
            <button type="button" @click="error_show = false" class="close">
              <span aria-hidden="true">&times;</span>
            </button>
            <div
              v-for="item in errors.items"
              :key="item.id"
              v-if="item.scope == 'pymt-form'"
            >
              <p class="fw-semi-bold">{{ item.msg }}</p>
            </div>
          </b-alert>
        </div>
      </b-col>
    </b-row>
    <b-form
      @submit.prevent="onSubmit('pymt-form')"
      id="payment_form"
      data-vv-scope="pymt-form"
      class="mt-1"
      style="margin-left: 3px; margin-right: 3px"
    >
      <div
        class="sales-bg pt-30p pb-4 mb-2 border-bottom-dot"
        style="background: #f7f7f7"
      >
        <!--  amcservice name -->
        <b-row>
          <b-col xl="10" lg="10" md="10" sm="12" xs="12">
            <form class="form-inline">
              <label class="my-1 mr-5" label-for="name">
                Customer Name
                <span class="text-danger pl-1">*</span>
              </label>
              <b-form-input
                style="width: 500px"
                type="text"
                v-model.trim="field.cus_id"
                size="sm"
                disabled
                name="cus_id"
                data-vv-name="customer"
                v-validate="'required'"
              />
            </form>
          </b-col>
        </b-row>
      </div>

      <b-row style="max-width: 1000px" class="mt-4">
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group
            :label="'Payment'"
            label-class="required"
            label-for="Payment-code"
            v-if="pymnt_settings_details.pymt_code_field"
            class="mb-3"
          >
            <b-input-group class="vselect-custom-add">
              <template slot="append">
                <b-input-group-text
                  class="vselect-custom-add-icon"
                  v-b-tooltip
                  title="Customize auto generate code"
                  style="margin-left: 2px"
                  v-on:click="
                    $root.$emit('bv::show::modal', 'addautogeneratecode')
                  "
                >
                  <i class="la la-cog"></i>
                </b-input-group-text>
              </template>
              <template slot="prepend">
                <b-form-input
                  style="
                    border-top-right-radius: 0 !important;
                    border-bottom-right-radius: 0 !important;
                  "
                  type="text"
                  size="sm"
                  name="Payment"
                  v-model.trim="field.pymnt_no"
                  data-vv-name="payment no"
                  v-validate="'required|max:16'"
                />
              </template>
            </b-input-group>
          </b-form-group>
          <b-form-group label="Payment Mode" label-for="Payment mode">
            <v-select
              :clearable="false"
              id="payment-method-select"
              data-vv-name="payment mode"
              v-validate="'required'"
              name="pymnt_mthd"
              v-model.trim="field.pymnt_mthd"
              index="value"
              label="label"
              placeholder="choose payment"
              size="sm"
              :options="details.paymentmethod"
            />
          </b-form-group>
          <b-form-group
            :label="'Amount received'"
            label-class="required"
            label-for="Amount_received"
          >
            <b-input-group
              :prepend="
                getDetails(
                  $AppDetails.currency_details,
                  field.cus_currency,
                  'currency_code'
                )
              "
              class="mb-2 mr-sm-2 mb-sm-0 payment_currency"
            >
              <input
                @blur="roundOff('paid_amount')"
                :disabled="field.disabled"
                type="text"
                class="form-control"
                size="sm"
                name="paid_amount"
                data-vv-name="amount received"
                v-validate="
                  'required|between:0,' +
                  field.due_amount +
                  '|excluded:' +
                  parseFloat(0).toFixed(2) +
                  '|max_value:' +
                  field.due_amount
                "
                v-model.trim="field.paid_amount"
              />
              <span class="pl-2 mr-0">
                <span
                  class="float-left display-flex mt-2"
                  style="font-size: 12px"
                  v-if="field.is_export == 2"
                >
                  1
                  {{
                    getDetails(
                      $AppDetails.currency_details,
                      field.cus_currency,
                      "currency_code"
                    )
                  }}
                  =
                  <b-form-input
                    disabled
                    @blur="
                      field.unit_currency_value =
                        parseFloat(field.unit_currency_value) <= 0
                          ? 1
                          : field.unit_currency_value
                    "
                    type="text"
                    v-model.trim="field.unit_currency_value"
                    class="ml-2 mr-2"
                    style="width: 100px; height: 22px !important"
                    name="Currency"
                    data-vv-name="currency"
                    v-validate="
                      'required|decimal:5|excluded:' +
                      parseFloat(0).toFixed(2) +
                      '|min_value:0'
                    "
                  />
                  {{
                    getDetails(
                      $AppDetails.currency_details,
                      $AppDetails.organization.org_currency,
                      "currency_code"
                    )
                  }}
                </span>
              </span>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group
            label="Deposit To"
            label-for="Deposit To"
            label-class="required"
            class="mb-3"
          >
            <select
              v-model.trim="field.deposit_mthd"
              v-chosen="field.deposit_mthd"
              name="Deposit To"
              data-vv-name="Deposit To"
              v-validate="'required'"
              class="chosen v-select form-control"
            >
              <template
                v-for="(item, index) in details.accounts.parent_accounts"
              >
                <optgroup :label="item.gl_acc_type" :key="index">
                  <template
                    v-if="
                      details.accounts.child_accounts[item.gl_acc_type_id]
                        .length != 0
                    "
                  >
                    <option
                      v-if="
                        (item.gl_acc_type_id!=6&&item.gl_acc_type_id!=21&& child.is_active == 1) ||
                      field.deposit_mthd == child.gl_acc_id||
                        ((item.gl_acc_type_id == 6 ||
                          item.gl_acc_type_id == 21) &&
                          (child.currency == field.cus_currency ||
                            child.currency == org_currency_id))
                      "
                      v-for="child in details.accounts.child_accounts[
                        item.gl_acc_type_id
                      ]"
                      :key="child.id"
                      :value="child.gl_acc_id"
                    >
                      {{
                        (item.gl_acc_type_id == 6 ||
                          item.gl_acc_type_id == 21) &&
                        child.bank_code
                          ? "[" + child.bank_code + "] "
                          : ""
                      }}{{ child.gl_acc_name }}
                    </option>
                  </template>
                </optgroup>
              </template>
            </select>
          </b-form-group>
          <b-form-group
            :label="'Payment date'"
            label-class="required"
            label-for="Payment Date"
            class="mb-3"
          >
            <DatePicker
              :format="$AppDetails.organization.date_format"
              data-vv-name="payment date"
              v-validate="'required'"
              input-name="created_date"
              lang="en"
              input-class="form-control"
              @change="selectDate"
              style="width: 100% !important"
              name="pymnt_date"
              v-model.trim="field.pymnt_date"
            >
              <i class="fa fa-calendar text-dark" slot="calendar-icon" />
            </DatePicker>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row style="max-width: 1000px" class="mt-4 mb-2 pt-2">
        <b-col>
          <h6
            class="text-primary pr-2 py-2 fw-semi-bold cursor_pointer h6-lg"
            v-b-toggle.other-details
          >
            Other details
            <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
          </h6>
        </b-col>
      </b-row>

      <b-collapse id="other-details" visible>
        <b-row style="max-width: 1000px">
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group
              label="Transaction No."
              label-for="Transaction"
              class="mb-3"
            >
              <b-form-input
                type="text"
                size="sm"
                v-model.trim="field.tns_no"
                data-vv-name="transaction no"
                v-validate="'max:20'"
                name="tns_no"
              />
            </b-form-group>
            <b-form-group
              label="Bank Charges(If any)"
              label-for="bank_charges"
              class="mb-3"
            >
              <input
                class="form-control"
                @blur="roundOff('bank_charges')"
                type="text"
                size="sm"
                data-vv-name="bank charges"
                v-validate="'required|decimal:2|max_value:' + field.paid_amount"
                name="bank_charges"
                v-model.trim="field.bank_charges"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group label="Reference No." label-for="ref_no" class="mb-3">
              <b-form-input
                type="text"
                size="sm"
                name="ref_no"
                data-vv-name="reference no"
                v-validate="'max:30'"
                v-model.trim="field.ref_no"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row style="max-width: 1000px" class="mt-3" v-if="page == 'invoice'">
          <b-col cols="12">
            <b-form-group
              horizontal
              label="Tax Deducted?"
              label-for="tax_deducted"
              :label-cols="2"
              class="mb-3"
            >
              <b-form-radio-group
                class="mt-2"
                id="filter_status"
                v-model="field.is_tax_deducted"
                @input="
                  field.is_tax_deducted == 0 ? (field.withheld_amount = '') : ''
                "
                :options="tax_deducted"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row
          style="max-width: 1000px"
          v-if="page == 'invoice' && field.is_tax_deducted == 1"
        >
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group
              :label="'Amount Withheld'"
              label-class="required"
              label-for="withheld_amount"
            >
              <input
                class="form-control"
                @blur="roundOff('withheld_amount')"
                type="text"
                size="sm"
                data-vv-name="with held amount"
                v-validate="'required|max:14'"
                name="withheld_amount"
                v-model.trim="field.withheld_amount"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group
              :label="'TDS Tax Account'"
              label-class="required"
              label-for="Payment mode"
            >
              <v-select
                :clearable="false"
                id="tds-account-select"
                data-vv-name="TDS tax accouont"
                v-validate="'required'"
                name="tds_tax_account"
                index="gl_acc_id"
                label="gl_acc_name"
                v-model.trim="field.tds_tax_account"
                placeholder="choose account"
                size="sm"
                :options="details.tds_acc_types"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-collapse>
      <b-row style="max-width: 1170px">
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-form-group class="mt-5 pb-2 pt-2">
            <!--  invoice extra notes -->
            <b-row>
              <b-col xl="7" lg="10" md="12" sm="12" xs="12">
                <label for="datetimepicker">Notes</label>
                <b-form-textarea
                  v-model.trim="field.pymnt_notes"
                  name="pymnt_notes"
                  :rows="4"
                  id="pymnt_notes"
                  data-vv-name="notes"
                  placeholder="Notes"
                  v-validate="'max:255'"
                />
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>

      <div>
        <!-- footer block -->
        <div class="footer">
          <div :class="{ 'form-action': true }">
            <b-button
              type="submit"
              variant="primary"
              class="btn-rounded mr-3"
              :disabled="submitted"
            >
              <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i
              >Record Payment
            </b-button>
          </div>
        </div>
      </div>
    </b-form>
    <AutoGenerateCode
      v-on:setCodeValue="getCodeValue($event)"
      :type="field.type||'payment_received'"
    ></AutoGenerateCode>
  </div>
</template>
<script scoped>
// import all the components, files and funciton
import AutoGenerateCode from "@/components/Modal/AutoGenerateCode";
import DatePicker from "vue2-datepicker"; // vue datepicker
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { mapState, mapGetters } from "vuex"; // to get the mapstate data of vuex
import { formatDate } from "@/mixins/formatDate"; // global fucntion for calling notification
import vSelect from "vue-select";
import $ from "jquery"; // for using jquery function

export default {
  props: ["lists", "page", "duplicatecode", "submitted","status_message"],
  mixins: [notificationMixin, formatDate],
  name: "Records", // page name
  components: {
    AutoGenerateCode,
    DatePicker, //datepicker
    vSelect,
  },
  data() {
    return {
      tax_deducted: [
        // radio button for taxable preferance
        {
          text: "No Tax deducted",
          value: "0",
        },
        {
          text: "Yes, TDS (Income Tax)",
          value: "1",
        },
      ],
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      field: {
        type: "",
        suffix: "",
        prefix: "",
        code_id: "",
        pymnt_no: "",
        cus_currency: "",
        is_export: 1,
        unit_currency_value: 1,
        cus_id: "",
        pymnt_date: "",
        deposit_mthd: "",
        is_tax_deducted: 0,
        tns_no: "",
        paid_amount: "0.00",
        withheld_amount: "0.00",
        bank_charges: "0.00",
        pymnt_mthd: "1",
        tds_tax_account: "",
        pymnt_notes: "",
        due_amount: "",
        ref_no: "",
      },
      error_show: false, // to show the error message
    };
  },
  methods: {
    redirectPage(){
       if(this.$route.query.page=='recurring'){
               this.$router.push({
              name: "RecurringInvoiceView",
              params: {
                id:this.$route.query.rec_id
              }
             });
            }
           else if(this.$route.query.page=='cus_adv'){
               this.$router.push({
              name: "CustomerAdvanceView",
              params: {
                id:this.$route.params.id
              }
             });
            }
             else if(this.$route.query.page=='retainerinvoice'){
               this.$router.push({
              name: "RetainerInvoiceView",
              params: {
                id:this.$route.params.id
              }
             });
            }
            else{
               this.$router.push({
              name: "InvoiceView"
            });
            }
     },
    //  update code details
    getCodeValue(ev) {
      this.field.code_id = ev.code_id;
      this.field.suffix = ev.suffix;
      this.field.prefix = ev.prefix;
      this.field.pymnt_no = ev.prefix + ev.suffix;
    },
    //  payemtn form details
    updatePayment() {
      this.field = this.lists;
      this.field.code_id = this.details.active_code_id.code_id;
      this.field.suffix = this.details.active_code_id.suffix;
      this.field.prefix = this.details.active_code_id.prefix;
      this.field.type = "payment_received";
      this.field.pymnt_no =
        this.details.active_code_id.prefix + this.details.active_code_id.suffix;
    },
    //    roundoff paid amount
    roundOff(field) {
      this.field[field] =
        typeof this.field[field] != undefined &&
        !isNaN(this.field[field]) &&
        this.field[field] != ""
          ? parseFloat(this.field[field]).toFixed(2)
          : parseFloat(0).toFixed(2);
    },
    selectDate(val) {
      //  if the payment term in selected customer not empty enter into condition
      this.field.pymnt_date =
        val == "" || typeof val == "undefined" || val == null
          ? ""
          : this.formatDate(val);
    },
    //validation during onsubmit
    onSubmit(scope) {
      if (this.page == "invoice" && this.field.is_tax_deducted == 1) {
        if (this.field.withheld_amount == 0) {
          this.field.is_tax_deducted = 0;
        }
        var total_paid_amount =
          parseFloat(this.field.paid_amount) +
          parseFloat(this.field.withheld_amount);

        if (total_paid_amount > parseFloat(this.field.due_amount)) {
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message:
              "You've recorded more payment than the actual invoice balance. Please check again.",
            type: "danger",
            showCloseButton: true,
          });
          return false;
        }
      }
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          //  send the json data

          this.$emit("onSubmit", this.field);
        } else {
          // Scroll to error message show
          var content = $(".container-fluid");
          content[0].scrollIntoView(false);
          this.error_show = true; // show validatioj message
        }
      });
      return false;
    },
  },
  async created() {
    this.message='';
    this.initializationMessengerCode();

    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air",
    };
    await this.updatePayment();
    //  to watch any updates in details data
    if (
      this.details.primary_acc.gl_acc_id != "" &&
      this.details.primary_acc.currency == this.field.cus_currency
    ) {
      this.field.deposit_mthd = this.details.primary_acc.gl_acc_id;
    } else {
      this.field.deposit_mthd = "46";
    }
  },

  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      details: (state) => state.payment.details,
    }),
     message: {
      get() {
        return this.$store.state.payment.message;
      },
      set(val) {
        this.$store.state.payment.message = val;
      }
    },
    ...mapGetters(["pymnt_settings_details","org_currency_id"]),
  },
};
</script>